require.context('../images/sites/', true, /\.(gif|jpg|png|svg|ico|webp)$/i)
// require.context('../svgs/', true, /\.(svg)$/i)
import 'stylesheets/sites'
import 'components/accordion/accordion'
import 'components/input/input'
import 'components/modal/modal'
// import Turbolinks from 'turbolinks'
import Rails from 'rails-ujs'

// Turbolinks.start()
Rails.start()
